import { useEffect, useState } from "react";
import { mdiStar, mdiStarOutline } from "@mdi/js";
import Icon from "@mdi/react";
import { uuid4 } from "@sentry/utils";

import styles from "./style.module.scss";

interface IProps {
  disabled?: boolean;
  readOnly?: boolean;
  value?: number;
  onChange?: (newRating: number) => void;
}

export default function Rater({
  disabled = false,
  readOnly = false,
  value = 0,
  onChange
}: Readonly<IProps>) {
  const [rating, setRating] = useState(value);

  useEffect(() => {
    setRating(value);
  }, [value]);

  const handleRatingChange = (newRating: number) => {
    setRating(newRating);
    if (onChange) {
      onChange(newRating);
    }
  };

  return (
    <div className={styles.smartRater}>
      {Array.from({ length: 5 })
        .map(() => ({ id: uuid4() }))
        .map((item, index) => {
          index += 1;

          return (
            <button
              type="button"
              key={item.id}
              onClick={() => handleRatingChange(index)}
              disabled={disabled || readOnly}>
              <Icon
                path={index <= rating ? mdiStar : mdiStarOutline}
                className={disabled ? "text-input" : "text-primary"}
              />
            </button>
          );
        })}
    </div>
  );
}
